import { Model } from "./";
import { Api } from "../api";

class s3Model extends Model {
  constructor() {
    super(new Api("/s3"));
  }

  uploadFileAttorney(clientId, formData, thenFunction, errorFunction) {
    this.q.setBaseUrl();
    this.q.setDopUrl("/attorney?clientId=" + clientId);
    this.q.uploadFile(formData, thenFunction, errorFunction);
  }
}

export default new s3Model();
